import dayjs, { Dayjs } from 'dayjs'

type DateType = string | number | Date | dayjs.Dayjs

export const formatDate = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format(dayjs.Ls[dayjs.locale()].formats.L)
}

export const formatDayAndNumber = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format('ddd DD')
}

export const formatDayAndNumberWithAbbreviatedMonth = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format('ddd DD MMM')
}

export const formatMonthAndYear = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format('MMMM YYYY')
}

export const formatTime = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format('HH:mm')
}

export const formatDateTime = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format(dayjs.Ls[dayjs.locale()].formats.L + ' HH:mm')
}

export const formatDateTimeWithSeconds = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date).format(dayjs.Ls[dayjs.locale()].formats.L + ' HH:mm:ss')
}

export const formatDateRange = (fromDate?: DateType, toDate?: DateType) => {
  if (!fromDate || !toDate) {
    return
  }

  const from = dayjs(fromDate)
  const to = dayjs(toDate)

  if (from.isSame(to, 'day')) {
    return `${formatDateTime(from)} - ${formatTime(to)}`
  } else {
    return `${formatDateTime(from)} - ${formatDateTime(to)}`
  }
}

export const getDateTimeUtcString = (
  date?: string | Dayjs | null,
  time?: string | Dayjs | null,
): string | null => {
  const dateObj = dayjs(date)

  if (!dateObj.isValid()) {
    return null
  }

  const hour = time ? dayjs(time).hour() : 0
  const minute = time ? dayjs(time).minute() : 0

  return dateObj.set('hour', hour).set('minute', minute).toISOString()
}

export const parseDate = (date?: DateType) => {
  if (!date) {
    return
  }

  return dayjs(date)
}

export const convertMinutesToHoursAndMinutes = (minutes?: number) => {
  if (minutes == null || minutes === undefined) {
    return { hours: undefined, minutes: undefined }
  }

  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  return { hours, minutes: mins }
}
